module.exports = __webpack_public_path__ + "img/gift.5db765bc.svg";